<template>
  <main id="settings" class="site-main">
    <div class="grid-container grid-container--x-small">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Account Settings</h1>
        </div>
      </div>

      <div class="panel">
        <div class="panel__content">
          <input name="store_id" type="hidden" value="">
          <input name="current_app" type="hidden" value="">

          <div class="form-field">
            <label for="email">Login Email</label>
            <input id="email" name="email" type="email"
                   :value="vendor ? vendor.account_email : ''">
          </div>

          <p v-if="$store.state.portalSettings.myshopify_domain == 'creative-goods-co.myshopify.com'">*** Please note that changing your email, address or other info on this platform WILL NOT notify Creative Goods. If you wish to change any information further to your signed agreement, please contact Brenna directly.</p>

          <div class="form-field" v-if="$store.state.portalSettings.country_code !== 'CA' && $store.state.portalSettings.myshopify_domain != 'creative-goods-co.myshopify.com' && $store.state.portalSettings.myshopify_domain != 'blast-team-stores.myshopify.com'">
            <label for="paypal-email">({{ vendor.name }}) PayPal Email</label>
            <input id="paypal-email" name="paypal-email" type="email"
                   :value="vendor ? vendor.paypal_email : ''">
          </div>

          <div class="text-success-color text-right"
               v-if="emailSuccess !== null" v-html="emailSuccess"></div>

          <div class="text-alert-color text-right"
               v-if="emailError !== null" v-html="emailError"></div>

          <div class="text-success-color text-right"
               v-if="paypalEmailSuccess !== null" v-html="paypalEmailSuccess"></div>

          <div class="text-alert-color text-right"
               v-if="paypalEmailError !== null" v-html="paypalEmailError"></div>
        </div>

        <div class="panel__footer text-right">
          <button @click="changeEmails">Save</button>
        </div>
      </div>

      <div class="panel">
        <div class="panel__content">
          <h3>Change Password</h3>

          <p><i>Please enter your old password, for security's sake, and then
            enter your new password twice so we can verify you typed it in
            correctly.</i></p>

          <div class="form-field">
            <label for="old-password">Old Password</label>
            <input id="old-password" name="old-password" type="password">
          </div>

          <ul>
            <li><small><i>Your password can't be too similar to your other
              personal information.</i></small>
            </li>
            <li><small><i>Your password must contain at least 8 characters.</i></small>
            </li>
            <li><small><i>Your password can't be a commonly used
              password.</i></small></li>
            <li><small><i>Your password can't be entirely numeric.</i></small>
            </li>
          </ul>

          <div class="form-field">
            <label for="new-password">New Password</label>
            <input id="new-password" name="new-password" type="password">
          </div>

          <div class="form-field">
            <label for="confirm-new-password">Confirm New Password</label>
            <input id="confirm-new-password" name="confirm-new-password"
                   type="password">
          </div>

          <div class="text-success-color text-right"
               v-if="passwordSuccess !== null" v-html="passwordSuccess"></div>

          <div class="text-alert-color text-right"
               v-if="passwordError !== null" v-html="passwordError"></div>
        </div>

        <div class="panel__footer text-right">
          <button @click="changePassword">Change Password</button>
        </div>
      </div>

      <div style="text-align: center;" v-if="$store.state.portalSettings.vendor_portal_terms !== undefined && $store.state.portalSettings.vendor_portal_terms.length > 0">
        <a :href="$store.state.portalSettings.vendor_portal_terms"
           target="_blank">{{ $store.state.portalSettings.name }} Terms & Conditions</a>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'

export default {
  name: 'vendorPortalSettings',
  mixins: [client],
  components: {},
  data: function () {
    return {
      emailSuccess: null,
      emailError: null,
      paypalEmailSuccess: null,
      paypalEmailError: null,
      passwordSuccess: null,
      passwordError: null
    }
  },
  methods: {
    changeEmails () {
      let emailElement = document.getElementById('email')

      this.vendor.account_email = emailElement.value

      this.emailSuccess = null
      this.emailError = null

      this.request('put', '/accounts/change-email/', {
        email: emailElement.value
      }).then(response => {
        this.emailSuccess = 'Login email updated successfully.'
      }).catch(error => {
        if (error) {
          this.emailError = 'Something went wrong updating the login email.'
        }
      })

      if (this.$store.state.portalSettings.country_code !== 'CA' && this.$store.state.portalSettings.myshopify_domain !== 'creative-goods-co.myshopify.com') {
        let paypalEmailElement = document.getElementById('paypal-email')
        this.vendor.paypal_email = paypalEmailElement.value
        this.paypalEmailSuccess = null
        this.paypalEmailError = null

        this.request('put', '/vendors/' + this.vendor.id + '/', {
          paypal_email: paypalEmailElement.value
        }).then(response => {
          this.paypalEmailSuccess = 'PayPal email updated successfully.'
        }).catch(error => {
          if (error) {
            this.paypalEmailError = 'Something went wrong updating the PayPal email.'
          }
        })
      }
    },
    changePassword () {
      let oldPasswordElement = document.getElementById('old-password')
      let newPasswordElement = document.getElementById('new-password')
      let confirmNewPasswordElement = document.getElementById('confirm-new-password')

      oldPasswordElement.style.borderColor = 'transparent'
      newPasswordElement.style.borderColor = 'transparent'
      confirmNewPasswordElement.style.borderColor = 'transparent'

      if (oldPasswordElement.value.length === 0) {
        oldPasswordElement.style.borderColor = '#cc4b37'
      }

      if (newPasswordElement.value.length === 0) {
        newPasswordElement.style.borderColor = '#cc4b37'
      }

      if (confirmNewPasswordElement.value.length === 0) {
        confirmNewPasswordElement.style.borderColor = '#cc4b37'
      }

      if (oldPasswordElement.value.length === 0 || newPasswordElement.value.length === 0 || confirmNewPasswordElement.value.length === 0) {
        this.passwordError = 'Please fill out all fields.'

        return true
      }

      if (newPasswordElement.value !== confirmNewPasswordElement.value) {
        this.passwordError = 'New and confirm passwords do not match.'

        return true
      }

      this.passwordSuccess = null
      this.passwordError = null

      this.request('put', '/accounts/change-password/', {
        old_password: oldPasswordElement.value,
        new_password1: newPasswordElement.value,
        new_password2: confirmNewPasswordElement.value
      }).then((response) => {
        this.passwordSuccess = 'Password has been updated'
      }).catch(error => {
        if (error) {
          this.passwordError = 'New password is not valid.'
        }
      })

      oldPasswordElement.value = ''
      newPasswordElement.value = ''
      confirmNewPasswordElement.value = ''
    }
  },
  computed: {
    vendor () {
      return this.$store.state.vendors[this.$store.state.currentVendor]
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/settings.vue